module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAXCAYAAAA/ZK6/AAABG0lEQVQ4jY3TsSuFYRTH8Y+bhbDZSbIx2Cz+AUpRlCyUKCUy3EE2ySQlCZNICSEkq8FkNhgMRlkUFqGnnlvc3tdzv+P7nG+d95zfqbo/Ks6gCdMqoIBnTGK2EqEau6jDKl6xnRICG6jBOj6wlxICK6jFJt5wkhICi6jHDgZwnRICRTTgAL24+f1YyGl1Cmc4RGclwhcmcBvF9pQQeMcwHnCO1pQgTqsfT7G95pQQeEEfGsN+KhHEEYc07GeNtZyxuNQ5rKWEoRib+VAs8dM92MISlksf84TumOKQq4XfD1lCF05xHPv+Q7nQEed9hXF8/ye04QJ3GMVnVq8lIdz0JR4xGGORSRBaYs/htsNGc4tLwkg8y1AcYpAPfgATpDiP9fL9LwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/pc/main/arrow-right.png
// module id = 7
// module chunks = 0